import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map, catchError, of, switchMap } from 'rxjs';
import { env, python } from 'src/environments/environments';
import { RestartPass } from '../interface/restartpass.interface';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RestartpassService {
/*   private readonly url = `${env.url_base}${env.api}${env.landing}${env.perfil_usuario}${env.administracion}${env.module.mailing_perfilUsuario_end}`;
  private readonly apiUrl = `${env.url_base}${env.api}${env.landing}${env.perfil_usuario}${env.module.api_perfilUser_end}`;
 */
  private readonly url2 = `${python.url_base}`;

  restarSubject = new BehaviorSubject<RestartPass|null>(null);
  restartUser$ = this.restarSubject.asObservable();

  constructor(private http:HttpClient,     private router: Router, ) { }

  codigo:number = 0;
  user:string = '';

  sendEmail(email:string, codigo:number, usuario:string): Observable<{ success: boolean, message: string }> {
    const urlResource: string = `${this.url2}/postEnvCorreo`;
    const domain = sessionStorage.getItem('domain') || '';
    const body = { email, codigo, usuario,domain};
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post<{ success: boolean, message: string, data: any }>(urlResource, body, {headers}).pipe(
      map(response => {
        if (response.success) {
          return { success: true, message: 'Correo enviado correctamente.' };
        } else {
          return { success: false, message: 'No se pudo enviar el correo. Intente nuevamente.' };
        }
      }),
      catchError((error: HttpErrorResponse) => {
        let errorMessage = this.getFriendlyErrorMessage(error);
        return of({ success: false, message: errorMessage });
      })
    );
  }

  updateAccessCodeAndSendEmail(email: string): Observable<{ success: boolean, message: string, data?: RestartPass }> {
    const body = { email };
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post<{ success: boolean, message: string, code: number, user: string }>(`${this.url2}/codigoTemporal`, body, { headers }).pipe(
      switchMap(response => {
        if (response.success) {
          this.codigo = response.code;
          this.user = response.user;
          return this.sendEmail(email, this.codigo, this.user);
        } else {
          return of({ success: false, message: response.message });
        }
      }),
      catchError((error: HttpErrorResponse) => {
        let errorMessage = this.getFriendlyErrorMessage(error);
        return of({ success: false, message: errorMessage });
      })
    );
  }


  private getFriendlyErrorMessage(error: HttpErrorResponse): string {
    if (!navigator.onLine) {
      return 'Conexión perdida, por favor revise su red.';
    }

    switch (error.status) {
      case 0:
        return 'No se pudo conectar al servidor. Verifique su conexión.';
      case 400:
        return 'Solicitud incorrecta. Por favor, revise los datos enviados.';
      case 401:
        return 'No autorizado. Por favor, inicie sesión nuevamente.';
      case 404:
        return 'Recurso no encontrado. Por favor, intente más tarde.';
      case 500:
        return 'Error interno del servidor. Intente nuevamente más tarde.';
      default:
        return 'Ocurrió un error inesperado. Por favor, intente de nuevo.';
    }
  }
}
